import {IOption} from "@pg-design/select-module";

import {TravelTimeValues} from "../types/TravelTimeValues";

export const timeOptions: IOption[] = [
    {label: "10 min", value: TravelTimeValues.TEN},
    {label: "20 min", value: TravelTimeValues.TWENTY},
    {label: "30 min", value: TravelTimeValues.THIRTY},
    {label: "45 min", value: TravelTimeValues.FORTY_FIVE},
    {label: "60 min", value: TravelTimeValues.SIXTY}
];
import {IOption} from "@pg-design/select-module";

import {TravelTimeValues} from "../types/TravelTimeValues";

export const timeOptions: IOption[] = [
    {label: "10 min", value: TravelTimeValues.TEN},
    {label: "20 min", value: TravelTimeValues.TWENTY},
    {label: "30 min", value: TravelTimeValues.THIRTY},
    {label: "45 min", value: TravelTimeValues.FORTY_FIVE},
    {label: "60 min", value: TravelTimeValues.SIXTY}
];
